import { Redirect, Route } from 'react-router-dom';
import { useAuth } from './auth-context';

const businessRegistranstionRoute = '/business-registration';
const PrivateRoute = ({ children, pathname, ...rest }) => {
  const userQuery = useAuth();
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (userQuery.data) {
          if (
            userQuery.data?.business_onboarding_status === 'create' &&
            pathname !== businessRegistranstionRoute
          ) {
            return (
              <Redirect
                to={{
                  pathname: '/business-registration',
                  state: { from: location }
                }}
              />
            );
          }
          return children;
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location }
              }}
            />
          );
        }
      }}
    />
  );
};

export default PrivateRoute;
